import styled from '@emotion/styled';
import { BodyTextMedium, Icon, pxToRem } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'src/shared/components/Collapse';

export const PathwaysCommonQuestions: React.FC<{ question: string; answer: string }> = ({
    question,
    answer,
}) => {
    const { t } = useTranslation();
    const [isAnswerVisible, setIsAnswerVisible] = React.useState(false);

    return (
        <QuestionWrapper>
            <QuestionHeader
                onClick={() => {
                    setIsAnswerVisible(!isAnswerVisible);
                }}
            >
                <BodyTextMedium fontColor="gray85" marginTop={20} marginBottom={20}>
                    {t(question)}
                </BodyTextMedium>

                <IconWrapper>
                    <Icon
                        name={isAnswerVisible ? 'chevron-up' : 'chevron-down'}
                        size={20}
                        color="gray85"
                    />
                </IconWrapper>
            </QuestionHeader>
            <Collapse visible={isAnswerVisible} noAnimationDelay>
                <Answer>{t(answer)}</Answer>
            </Collapse>
        </QuestionWrapper>
    );
};

const QuestionWrapper = styled.div({
    borderTop: `${pxToRem(2)} solid ${colors.gray05}`,
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
});

const QuestionHeader = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
});

const IconWrapper = styled.div({
    display: 'flex',
    alignItems: 'center',
});

const Answer = styled.div({
    marginBottom: pxToRem(20),
});
